export class ReponseActionApiBase {
  estSucces: boolean;
  estEchec: boolean;
  messages: ActionApiMessage[];
}

export class ReponseActionApi<T> extends ReponseActionApiBase {
  valeur: T;
}

export class Alert {
  type: string;
  msg: string;
}

export class ActionApiMessage extends Alert {
  id: string;
}

export class ActionApiMessageChamp extends ActionApiMessage {
  clickable: boolean;
}

export class KeyPairs {
  key: string;
  value: string | string[];
}

export class PageModel<T> {
  criteres: string;
  page: number;
  pageCount: number;
  data: Array<T>;
  recordCount: number;
  orderBy: string;
  orderDirection: string;
  pageSize: number;
}

export class AlertModal {
  titre: string;
  alert: Alert;
  texteOk: string;
}

export class Notification {
  message: string;
  titre: string;
}

export enum ActionMsgType {
    danger = 'danger',
    info = 'info',
    warning = 'warning',
    success = 'success'
}
